import request from "../request";
import Url from "../url/member";

const getUserList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getUserList + path, data, options);
};
const getUserListDeatils = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getUserListDeatils + path, data, options);
};
const setAccountData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setAccountData + path, data, options);
};
const updateAccountData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateAccountData + path, data, options);
};
const updateMemberAgree = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateMemberAgree + path, data, options);
};
const getKnowledgesCountsRecordDataMyMemberid = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getKnowledgesCountsRecordDataMyMemberid + path,
    data,
    options
  );
};

export default {
  getUserList,
  getUserListDeatils,
  setAccountData,
  updateAccountData,
  updateMemberAgree,
  getKnowledgesCountsRecordDataMyMemberid,
};
